<app-page-header title='Berichten'></app-page-header>

<div class='container notification-channels' *ngIf='isAdmin$ | async'>
  <div class='mt-3'>
    <div class='card'>
      <div class='body'>
        <h1>Reviewverzoeken</h1>
        <p class='muted'>
          Via welke kanalen wordt een reviewverzoek klaargezet zodra een werkbon is afgerond?
        </p>
        <div class='form' [formGroup]='channelsForm'>
          <div class='form-group d-flex' *ngFor='let option of channelOptions'>
            <input type='checkbox' id='channel-{{option.value}}' [formControlName]='option.value'>
            &nbsp;
            <label class='label' for='channel-{{option.value}}'>{{ option.label }}</label>
          </div>
        </div>
        <p class='muted'>
          Vink je niets aan, dan worden er helemaal geen reviewverzoeken meer klaargezet.
        </p>
        <button class='btn btn-success' (click)='saveChannels()' [disabled]='isSavingChannels'>Opslaan</button>
      </div>
    </div>
  </div>
</div>

<ng-container *ngIf='templates$ | async as templates'>
  <div class='container all-chats'>
    <div class='mt-3 mb-3'>
      <div class='card'>
        <div class='body'>
          <h1>Alle chats</h1>
        </div>
      </div>
    </div>
    <div class='container chats' *ngIf='allChats$ | async as chats'>
      <div class='row'
           [class.unread]='chat.lastMessage.read == null && chat.lastMessage.sentByUs'
           *ngFor='let chat of chats | paginate: { id: "all", itemsPerPage: 10, currentPage: allChatsPage }'
           (click)='openChat(chat.address?.id)'>
        <div class='col-10'>
          {{ chat.address?.contact }}<br>
          <span class='message'>
          {{ getPreview(chat.lastMessage, templates) }}
        </span>
        </div>
        <div class='col-2 chat-time'>
          {{ chat.lastMessage.created | date:'yyyy-MM-dd HH:mm' }}
        </div>
      </div>
    </div>
    <div class='text-center'>
      <pagination-controls
        id='all'
        previousLabel='Vorige'
        nextLabel='Volgende'
        (pageChange)='allChatsPage = $event'>
      </pagination-controls>
    </div>
  </div>

  <div class='container chat-queue'>
    <div class='mt-3 mb-1'>
      <div class='card'>
        <div class='body'>
          <h1>Berichten wachtrij</h1>
        </div>
      </div>
    </div>
    <div class='container chats' *ngIf='chatQueue$ | async as chats'>
      <div class='row'
           *ngFor='let chat of chats | paginate: { id: "unsent", itemsPerPage: 10, currentPage: chatsQueuePage }'>
        <div class='col-8'>
          <span class='badge badge-{{ chat.lastMessage.channel }}'>
            {{ getChannelLabel(chat.lastMessage.channel) }}
          </span>
          {{ chat.address?.contact }}<br>
          <span class='subject' *ngIf='chat.lastMessage.subject'>
            {{ chat.lastMessage.subject }}<br>
          </span>
          <span class='message'>
          {{ getPreview(chat.lastMessage, templates) }}
        </span>
        </div>
        <div class='col-2 chat-time'>
          <ng-container *ngIf='!!chat.lastMessage.scheduled else noDateSet'>
            {{ chat.lastMessage.scheduled | date:'yyyy-MM-dd HH:mm' }}
          </ng-container>
          <ng-template #noDateSet>
            <span class='not-scheduled'>Niet ingepland</span>
          </ng-template>
        </div>
        <div class='edit' *ngIf='chat.lastMessage.sent == null && chat.lastMessage.sentByUs'>
          <a (click)='editMessage($event, chat.lastMessage)'>
            Bewerken
          </a>
        </div>
      </div>
    </div>
    <div class='text-center'>
      <pagination-controls
        id='unsent'
        previousLabel='Vorige'
        nextLabel='Volgende'
        (pageChange)='chatsQueuePage = $event'>
      </pagination-controls>
    </div>
  </div>
</ng-container>
